<template>
    <div id="planning_kecamatan" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Data Wilayah Kecamatan</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="getDataKabupaten()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-info">
                        <th style="width: 5%">No.</th>
                        <th style="width: 10%">Kode Provinsi</th>
                        <th style="width: 10%">Kode Kabupaten</th>
                        <th style="width: 10%">Kode Kecamatan</th>
                        <th style="width: 18%">Nama Provinsi</th>
                        <th style="width: 18%">Nama Kabupaten</th>
                        <th style="width: 18%">Nama Kecamatan</th>
                        <th style="width: 20%">Pilihan</th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr class="h_isitable" v-for="(data, index) in list_kecamatan" :key="data.kecamatan_id">
                            <td>{{index+1}}</td>
                            <td>{{data.kode_provinsi}}</td>
                            <td>{{data.kode_kabupaten}}</td>
                            <td>{{data.kode_kecamatan}}</td>
                            <td>{{data.nama_provinsi}}</td>
                            <td>{{data.nama_kabupaten}}</td>
                            <td>{{data.nama_kecamatan}}</td>

                            <td class="text-center" >

                            <button @click="selectData(data.kecamatan_id,data.kode_kecamatan,data.nama_kecamatan,data.kabupaten_id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                <i class="material-icons" >create</i>
                            </button>
                                &nbsp;
                            <button @click="removeData(data.kecamatan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                <i class="material-icons" >clear</i>
                            </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                    </button>
                    &nbsp;
                    <span style="font-size: 85%; color: #a5a5a5">
                        <b>{{page_first}} - {{page_last}}</b>
                    </span>
                    &nbsp;
                    <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>

            <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                            </div>
                        <form @submit.prevent="addData()">

                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <select v-model="data.kabupaten_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Kabupaten --</option>
                                            <option v-for="(data) in list_kabupaten" :key="data.kabupaten_id" v-bind:value="data.kabupaten_id">	&#91;{{data.kode_provinsi}}.{{data.kode_kabupaten}}&#93; {{data.nama_kabupaten}}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Kecamatan</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="data.kode_kecamatan" :required="true" id="kode_provinsi" class="form-control" placeholder="Kode Kecamatan">
                                    </div>
                                </div>
                                </div>
                            </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.nama_kecamatan"  :required="true" type="text" id="nama_provinsi" class="form-control" placeholder="Nama Kecamatan">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                        </form>

                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-green">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                            </div>
                            <form @submit.prevent="editData()">

                            <div class="modal-body">
 

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <select v-model="kabupaten_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Kabupaten --</option>
                                            <option v-for="(data) in list_kabupaten" :key="data.kabupaten_id" v-bind:value="data.kabupaten_id">	&#91;{{data.kode_provinsi}}.{{data.kode_kabupaten}}&#93; {{data.nama_kabupaten}}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Kecamatan</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text"  v-model="kode_kecamatan" id="kode_urusan" class="form-control" placeholder="Kode Kecamatan">
                                    <input type="hidden" v-model="kecamatan_id" id="urusan_pemerintahan_id" class="form-control" >
                                    </div>
                                </div>
                                </div>
                            </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input type="text" v-model="nama_kecamatan" id="nama_urusan" class="form-control" placeholder="Nama Kecataman">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_kecamatan/';
    const ADD_URL_KAB = URL_APP+'api/v1/planning_kabupaten/';
    export default {
        name: "planning_kabupaten",
        data() {
            return {
                data:{
                    kode_kecamatan: '',
                    nama_kecamatan: '',
                    kecamatan_id: '',
                    kabupaten_id: '',
                },
                kode_kecamatan: '',
                nama_kecamatan: '',
                kecamatan_id: '',
                kode_kabupaten: '',
                nama_kabupaten: '',
                kabupaten_id: '',
                list_kecamatan: [],
                list_kabupaten: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                //   console.log(data_urusan);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_kecamatan = datanya.data;
                  this.page_last = datanya.jml_data;
                //   console.log(datanya);
                })
            },
            getDataKabupaten: function(){
                fetch(ADD_URL_KAB+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_kabupaten = data_urusan.data;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        kabupaten_id: this.kabupaten_id,
                        nama_kecamatan: this.nama_kecamatan,
                        kode_kecamatan: this.kode_kecamatan,
                        kecamatan_id: this.kecamatan_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(a,b,c,d){
                this.kabupaten_id = d;
                this.kecamatan_id = a;
                this.kode_kecamatan = b;
                this.nama_kecamatan = c;
                this.getDataKabupaten();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    kode_kecamatan: '',
                    nama_kecamatan: '',
                    kecamatan_id: '',
                    kabupaten_id: '',
                };
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
